import ApiService from './ApiService.js';
const uuidv1 = require('uuid/v1');
 
var TokenService = {
    renewToken: function($data) {
        return new Promise(function (resolve, reject) {
            var $options = {};
            $options.data={};
            $options.data  = JSON.parse(localStorage.getItem(process.env.VUE_APP_LOCAL_STORAGE))
            $options.data = $options.data.User
            $options.url ='renewToken'
            $options.data = $data;
            ApiService.request($options) 
                .then(response => {
                    resolve(response.data)
                }).catch(error => {
                    reject(error)
                });
        });
    }
}
export default TokenService;



